<template>
    <div class="dharma_realm_box">
            <div class="dharma_realm">
                <div class="title_box">
                    <div class="title_text1">法界热点</div>
                    <div class="title_text2">LEGAL HOT SPOTS</div>
                    <div class="title_img">
                        <img src="../../assets/img/index/home/right1.png" alt="">
                    </div>
                </div>
                <div class="dharma_cehck_list">
                    <div class="tab_list" v-for="(item,index) in dharma_cehck_list" :key="index" :class="{tab_list_ac:dharma_cehck_ac==item.id}" @click="handle_dharma_cehck(item,index)">
                        <div class="tab_title">
                            {{ item.title }}
                        </div>
                        <div class="borders"></div>
                    </div>
                </div>
                <div class="dharma_realm_flex" v-loading="loading">
                    <div class="lefts">
                        <div class="dharma_realm_new" v-for="(item,index) in dharma_list" :key="index" @click="handle_detial(item)">
                            <div class="imgs">
                                <img :src="item.thumb" alt="">
                            </div>
                            <div class="info_box">
                                <div class="titles">
                                    {{ item.title }}
                                </div>
                                <div class="consts">
                                    {{ item.description }}
                                </div>
                                <div class="num_box">
                                    <div class="num_flex">
                                        <div class="icon_num">
                                            <img src="@/assets/img/index/home/time.png" alt="">
                                            {{ item.created_at }}
                                        </div>
                                        <div class="icon_num">
                                            <img src="../../assets/img/index/home/see.png" alt="">{{ item.view_num }}
                                        </div>
                                    </div>
                                    <div class="btns">
                                        查看详情
                                        <span>+</span>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="rights">
                        <div class="title_box">
                            <div class="titles">最新知识</div>
                            <div class="btn_text" @click="handle_ljxq">了解详情+</div>
                        </div>
                        <div class="new_list">
                            <div class="new_item" v-for="(item,index) in latest_list" :key="index"  @click="handle_detial(item)">
                                <!-- 【施工合同纠纷】建筑合同违约规定是怎么样的? -->
                                 {{item.title}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading: false,
            
            dharma_cehck_ac:0,
            dharma_cehck_list:[],
            dharma_list:[],
            latest_list:[],
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        this.get_dharma_cehck_list()
        this.get_latest_list()
    },
    methods: {
       
        handle_dharma_cehck(item,index){
            this.dharma_cehck_ac=item.id
            this.get_dharma_list()

        },
        get_dharma_cehck_list(){
            this.loading=true
            this.$api("getArticleCategoryList", {
                parent_id:4,
			}, "get").then((res) => {
                this.loading = false
                console.log('首页法界热点分类1',res)
                if (res.code == 1) {
                    this.dharma_cehck_list=res.data
                    if(res.data.length>0){
                        this.dharma_cehck_ac=res.data[0].id 
                    }
                    this.get_dharma_list()
                } else {
                    alertErr(res.msg)
                }
            });
        },
        get_dharma_list(){
            this.loading=true
            this.$api("getArticleList", {
                limit:2,
                category_id:this.dharma_cehck_ac,
			}, "get").then((res) => {
                this.loading = false
                console.log('首页法界热点列表',res)
                if (res.code == 1) {
                    this.dharma_list=res.data.list
                  
                    this.dharma_list.forEach((e)=>{
                        e.created_at=e.created_at.substring(0,10)
                    })
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_detial(item){
            this.$router.push({
                path:'/hot_spot_type_detial',
                query:{
                    id:item.id
                },
            })
            // 
        },
        handle_ljxq(){
            this.$router.push({
                path:'/hot_spot',
                query:{
                    
                },
            })
        },
        get_latest_list(){
            this.loading=true
            this.$api("getArticleList", {
                limit:7,
                category_id:14,
			}, "get").then((res) => {
                this.loading = false
                console.log('首页法界热点的最新知识列表',res)
                if (res.code == 1) {
                    this.latest_list=res.data.list
                } else {
                    alertErr(res.msg)
                }
            });
        },




    },

}
</script>
<style scoped lang="less">
   .dharma_realm_box{
        width: 100%;
        padding-top: 110px;
        background: #fff;
        .dharma_realm{
            width: 1440px;
           
            padding-bottom: 11px;
            margin: auto;
            .title_box {
                display: flex;
                align-items: end;

                // align-content: end;
                // justify-content: space-between;
                .title_text1 {
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 36px;
                    color: #333333;

                }

                .title_text2 {
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 24px;
                    color: #377CFD;
                    margin-left: 16px;
                }

                .title_img {
                    width: 24px;
                    height: 24px;
                    margin-left: 16px;

                    img {
                        width: 24px;
                        height: 24px;
                    }
                }
            }
            .dharma_cehck_list{
                display: flex;
                align-items: center;
                padding-top: 50px;
                // padding-bottom: 20px;
                border-bottom: 2px solid #EDEDED;
                .tab_list{
                    margin-right: 80px;
                    cursor: pointer;
                    // height: 100%;
                    .tab_title{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 18px;
                        color: #999999;
                    }
                    .borders{
                        width: 72px;
                        height: 3px;
                        background: #fff;
                        margin-top: 18px;
                        border-radius: 0px 0px 0px 0px;
                    }

                    &:hover{
                        .tab_title{
                            color: #377CFD;
                        }
                        .borders{
                            background: #377CFD;
                        }
                    }
                }
                .tab_list_ac{
                    .tab_title{
                        color: #377CFD;
                    }
                    .borders{
                        background: #377CFD;
                    }
                }
            }
            .dharma_realm_flex{
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-top: 40px;
                .lefts{
                    display: flex;
                    align-items: center;
                    .dharma_realm_new{
                        width: 416px;
                        height: 486px;
                        background: #FFFFFF;
                        box-shadow: 0px 4px 40px 1px rgba(43,89,255,0.08);
                        border-radius: 8px 8px 8px 8px;
                        margin-right: 40px;
                        .imgs{
                            width: 416px;
                            height: 280px;
                            background: #C4C4C4;
                            border-radius: 8px 8px 0px 0px;
                            img{
                                width: 416px;
                                height: 280px;
                            }
                        }
                        .info_box{
                            padding: 24px;
                            .titles{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 20px;
                                color: #333333;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                            .consts{
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 3;
                                -webkit-box-orient: vertical;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;
                                padding-top: 14px;
                            }
                            .num_box{
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                padding-top: 26px;
                                .num_flex{
                                    display: flex;
                                    align-items: center;
                                    
                                    .icon_num{
                                        display: flex;
                                        align-items: center;
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 14px;
                                        color: #999999;
                                        margin-right: 16px;
                                        img{
                                            height: 18px;
                                            margin-right: 8px;
                                        }
                                    }
                                }
                                .btns{
                                    cursor: pointer;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #377CFD;
                                }
                            }

                        }
                    }
                }
                .rights{
                    width: 528px;
                    height: 486px;
                    background: #FFFFFF;
                    box-shadow: 0px 4px 40px 1px rgba(55,124,253,0.08);
                    border-radius: 8px 8px 8px 8px;
                    padding: 40px;
                    .title_box{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .titles{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 20px;
                            color: #333333;
                        }
                        .btn_text{
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;

                        }
                    }
                    .new_list{
                        padding-top: 32px;
                        .new_item{
                            padding-bottom: 20px;
                            border-bottom: 2px solid #EDEDED;
                            margin-bottom: 12px;
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                        }
                        .new_item:last-child{
                            border-bottom:0;

                        }
                    }
                }
            }
        }
    }
</style>